import { render } from "./AboutSectionMobile.vue?vue&type=template&id=24816068&scoped=true"
import script from "./AboutSectionMobile.vue?vue&type=script&lang=js"
export * from "./AboutSectionMobile.vue?vue&type=script&lang=js"

import "./AboutSectionMobile.vue?vue&type=style&index=0&id=24816068&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-24816068"]])

export default __exports__